import { createGlobalStyle } from 'styled-components'
import styledNormalize from 'styled-normalize'

import 'react-datepicker/dist/react-datepicker.css'
import 'src/styles/date-picker.css'

/**
 * Global base styles
 */

const GlobalStyle = createGlobalStyle`
  ${styledNormalize}

  html,
  body {
    font-family: ${({ theme }) => theme.typography.fontFamily};
  }

  html {
    box-sizing: border-box;
    height: 100%;
  }

  body {
    position: relative;
  }

  a {
    color: inherit;
    text-decoration: none;

    &:hover {
      color: ${({ theme }) => theme.palette.primary.main};
    }
  }

  label {
    font-size: ${({ theme }) => theme.typography.pxToRem(18)};
    line-height: ${({ theme }) => theme.typography.pxToRem(36)};
  }

  *,
  *:before,
  *:after {
    box-sizing: inherit;
  }

  img {
    max-width: 100%;
  }

  fieldset {
    margin: 0;
    padding: 0;
    border: 0;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  /* clears the 'X' from Internet Explorer */
  input[type='search']::-ms-clear {
    display: none;
    width: 0;
    height: 0;
  }
  input[type='search']::-ms-reveal {
    display: none;
    width: 0;
    height: 0;
  }

  /* clears the 'X' from Chrome */
  input[type='search']::-webkit-search-decoration,
  input[type='search']::-webkit-search-cancel-button,
  input[type='search']::-webkit-search-results-button,
  input[type='search']::-webkit-search-results-decoration {
    display: none;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    transition: background-color 5000s ease-in-out 0s;
  }

  @font-face {
    font-family: "ProximaNova";
    font-weight: ${({ theme }) => theme.weights.fontWeightLight};
    src: url("/assets/fonts/ProximaNova/ProximaNova-Light.otf") format("opentype");
  }

  @font-face {
    font-family: "ProximaNova";
    font-weight: ${({ theme }) => theme.weights.fontWeightRegular};
    src: url("/assets/fonts/ProximaNova/ProximaNova-Regular.otf") format("opentype");
  }

  @font-face {
    font-family: "ProximaNova";
    font-weight: ${({ theme }) => theme.weights.fontWeightMedium};
    src: url("/assets/fonts/ProximaNova/ProximaNova-Medium.otf") format("opentype");
  }

  @font-face {
    font-family: "ProximaNova";
    font-weight: ${({ theme }) => theme.weights.fontWeightSemiBold};
    src: url("/assets/fonts/ProximaNova/ProximaNova-SemiBold.otf") format("opentype");
  }

  @font-face {
    font-family: "ProximaNova";
    font-weight: ${({ theme }) => theme.weights.fontWeightBold};
    src: url("/assets/fonts/ProximaNova/ProximaNova-Bold.otf") format("opentype");
  }


  /* Add @font-face here */

 `

export default GlobalStyle
